export const boilerData = [
    {
        image: './images/boilertest.jpg',
        title: 'ecoTEC plus combi 30kw',
        info: 'The ecoTEC plus, with its range of heating outputs, is so flexible it can meet the demands of a whole range of homes and different lifestyles. That’s why it’s our flagship boiler.',
        radPower: '17',
        flowRate: '15.9',
        heatOutput: '30kw',
        warrenty: '10 years',
        price: '£2667',
        perMonth: '£26.89',
    },
    {
        image: './images/greenq.jpg',
        title: 'ecoTEC exclusive with Green iQ combi',
        info: 'The ecoTEC exclusive is the best in the business. It has our unique Green iQ mark which means it gives you the ultimate in energy efficiency.',
        radPower: '17',
        flowRate: '17.8',
        heatOutput: '35kw',
        warrenty: '10 years',
        price: '£3467',
        perMonth: '£34.89',
    },
    {
        image: './images/idealcombi.png',
        title: 'Ideal Logic Max Combi',
        info: 'Based on our award winning Logic+ range the Logic Max Combi combines the Logic+ with our Ideal System Filter giving a full 10 year warranty.',
        radPower: '17',
        flowRate: '16.3',
        heatOutput: '30kw',
        warrenty: '10 years',
        price: '£1999',
        perMonth: '£24.89',
    },
    {
        image: './images/idealvouge.png',
        title: 'Ideal Vogue Gen2 Combi',
        info: 'The Vogue GEN2 range combines modern technology with premium components to bring the next step in domestic heating',
        radPower: '17',
        flowRate: '16.3',
        heatOutput: '30kw',
        warrenty: '10 years',
        price: '£2467',
        perMonth: '£24.89',
    },
    {
        image: './images/viess.png',
        title: 'Viessman Vitodens 100-W',
        info: 'Flexible, powerful and easy to maintain, the wall mounted gas condensing Vitodens 200-W is ideal for larger detached and semi-detached homes.',
        radPower: '17',
        flowRate: '15.3',
        heatOutput: '30kw',
        warrenty: '10 years',
        price: '£2337',
        perMonth: '£23.89',
    },
  /*   {
        image: './images/boilertest.jpg',
        title: 'Baxi 600 Combi',
        info: 'This compact, powerful boiler can be operated using smart controls through an app on your phone or tablet.',
        radPower: '17',
        flowRate: '15',
        heatOutput: '34kw',
        warrenty: '10 years',
        price: '£2237',
        perMonth: '£22.69',
    }, */
]